/**
 * DetailPanel
 * - dynamically display the content selected in detail-selector
 * - pass property data as a prop to the selected detail view
 */
import React from 'react';
import { Theme } from '@mui/material/styles';
import { MyProperty } from './property-view';
import { ViewOption } from './property-view-detail-selector';
import { useIsLargeScreen } from '../../../../system/SystemMediaQueriesProvider';

interface DetailPanelProps {
  theme: Theme;
  viewOption: ViewOption;
  data?: MyProperty;
}
export function PropertyViewDetailPanel(props: DetailPanelProps) {
  const { data, theme } = props;
  const isLarge = useIsLargeScreen();
  const Component = props.viewOption.view;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        alignItems: 'stretch',
      }}
    >
      <Component data={data} theme={theme} />
    </div>
  );
}
